/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are words separated?`)
};

const es_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se separan las palabras?`)
};

const de_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie werden Wörter getrennt?`)
};

const nl_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe worden woorden gescheiden?`)
};

const fr_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les mots sont-ils séparés ?`)
};

const it_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono separate le parole?`)
};

const pt_br2_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como as palavras são separadas?`)
};

const pt_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como as palavras são separadas?`)
};

const ja_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語はどのように分離されていますか?`)
};

const zh_mc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单词之间是如何分隔的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_faq1_q", locale)
	if (locale === "en") return en_mc_faq1_q(inputs)
	if (locale === "es") return es_mc_faq1_q(inputs)
	if (locale === "de") return de_mc_faq1_q(inputs)
	if (locale === "nl") return nl_mc_faq1_q(inputs)
	if (locale === "fr") return fr_mc_faq1_q(inputs)
	if (locale === "it") return it_mc_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_mc_faq1_q(inputs)
	if (locale === "pt") return pt_mc_faq1_q(inputs)
	if (locale === "ja") return ja_mc_faq1_q(inputs)
	return zh_mc_faq1_q(inputs)
};